import React, { useState } from 'react';
import Topbar from '../components/Topbar';
import './ComparePage.css';

interface Proposicao {
  tipo: string;
  numero: number;
  ano: number;
  titulo: string;
  autor: string;
  status: string;
  votacoes: number;
}

const mockProps: Proposicao[] = [];

export default function ComparePage() {
  const [selected, setSelected] = useState<Proposicao[]>([]);

  const handleRemove = (idx: number) => {
    setSelected(selected.filter((_, i) => i !== idx));
  };

  const criteria = [
    { label: 'Tipo', key: 'tipo' },
    { label: 'Número', key: 'numero' },
    { label: 'Ano', key: 'ano' },
    { label: 'Autor', key: 'autor' },
    { label: 'Status', key: 'status' },
    { label: 'Votações', key: 'votacoes' },
  ];

  return (
    <div className="compare-container">
      <Topbar title="Comparar" badge="mocks" />
      <div className="compare-content">
        <h2>Comparar Proposições</h2>

        {selected.length > 0 ? (
          <div className="compare-table">
            <table>
              <thead>
                <tr>
                  <th>Critério</th>
                  {selected.map((prop, idx) => (
                    <th key={idx}>
                      <div className="prop-header">
                        <div className="prop-title">
                          {prop.tipo} {prop.numero}/{prop.ano}
                        </div>
                        {selected.length > 1 && (
                          <button className="remove-btn" onClick={() => handleRemove(idx)}>
                            ✕
                          </button>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {criteria.map((c) => (
                  <tr key={c.key}>
                    <td className="criteria-name">{c.label}</td>
                    {selected.map((prop, idx) => (
                      <td key={idx}>{String((prop as any)[c.key])}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="compare-empty">
            <p>Nenhuma proposição selecionada</p>
          </div>
        )}
      </div>
    </div>
  );
}
